export const DefaultBorderSizes = {
  0: '0px' as const,
  1: '1px' as const,
  2: '2px' as const,
  3: '3px' as const,
  4: '4px' as const,
}

export type BorderSizes = typeof DefaultBorderSizes

export const DefaultBorderRadius = {
  0: '0rem' as const,
  4: '0.4rem' as const,
  6: '0.6rem' as const,
  8: '0.8rem' as const,
  10: '1rem' as const,
  12: '1.2rem' as const,
  16: '1.6rem' as const,
  20: '2rem' as const,
  24: '2.4rem' as const,
  circle: '50%' as const,
  full: '9999rem' as const,
}

export type BorderRadius = typeof DefaultBorderRadius
